import lists from './lists';

export default {
  lists,
};
